import { NuqsAdapter } from "nuqs/adapters/react"

import ProductCatalogue from "@components/V2/Sections/ProductCatalogue"
import { useShopItems } from "@hooks/V2/storyblok/useShopItems"
import { storyblokLinkToYocoLink } from "@utils/storyblok"
import { consolidatedItemToProductCard } from "@utils/V2/productCard"
import React from "react"

const StoryblokProductCatalogue = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ProductCatalogue>) => {
  const { catalogueItems } = useShopItems(blok.useInternalItems)

  const products = catalogueItems.map(consolidatedItemToProductCard)

  return (
    <NuqsAdapter>
      <ProductCatalogue
        filterPanel={blok.filterPanel.map((filter) => ({
          ...filter,
          mobileOrder: Number(filter.mobileOrder),
        }))}
        products={products}
        subFilterTitle={blok.subFilterTitle}
        subFilterDescription={blok.subFilterDescription}
        subFilterCtaText={blok.subFilterCtaText}
        subFilterCtaLink={storyblokLinkToYocoLink(blok.subFilterCtaLink)}
      />
    </NuqsAdapter>
  )
}

export default StoryblokProductCatalogue
